import { useSelector } from 'react-redux';
import { checkSitePermission } from '../../../store/slices/user';
import { UserRolePermissions } from '../../../constants';
import ProtectRoute from '../../../HOCs/protectAuth';
import { Header } from '../../../components';
import Footer from '../../../components/Footer';
import HotelPageInfo from '../../../components/HotelPageInfo';
import PageLayout from '../../../layouts/PageLayout';

const HotelPage = () => {
  const canViewPages = useSelector(checkSitePermission(UserRolePermissions.canViewPages));
  return (
    <PageLayout>
      <ProtectRoute doContinueWithoutLogin={canViewPages} doPasswordProtectPage>
        <div className="min-h-screen flex flex-col">
          <Header doShowSearchbar doShowNavbar />
          <div className="w-full overflow-hidden mx-auto px-2 sm:px-0 min-h-112 bg-white flex-grow">
            <HotelPageInfo />
          </div>
          <Footer />
        </div>
      </ProtectRoute>
    </PageLayout>
  );
};

export default HotelPage;
